import React from 'react';
import { withFormsy } from 'formsy-react';

import FieldError from './FieldError'

class Select extends React.Component {
  constructor(props) {
    super(props);

    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    // setValue() will set the value of the component, which in
    // turn will validate it and the rest of the form
    // Important: Don't skip this step. This pattern is required
    // for Formsy to work.

    this.props.setValue(event.currentTarget.value);
    this.props.onChange && this.props.onChange(event.currentTarget.value)
  }

  render() {
    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const errorClass = errorMessage ? "has-error" : ""
    const {ignoreFirstReadonly} = this.props

    const options = (this.props.options || []).map((option, i) => (
      <option key={option.value} value={option.value}>
        {option.title}
      </option>
    ));

    let color = "#b0b0b1"

    const value = this.props.getValue() || ""
    if ((value && value !== "") || ignoreFirstReadonly)
      color = "#354052"

    return (
      <div className={`${this.props.className} ${errorClass}`}>
        <select style={{color: color, cursor: "pointer"}} className={this.props.classNameSelect} name={this.props.name} onChange={this.changeValue} value={this.props.getValue()}>
          {options}
        </select>
        { errorMessage && <FieldError message={errorMessage} /> }
      </div>
    );
  }
}

export default withFormsy(Select);
